export const anrokSupportedCountryCodes = [
  'AU', // Australia
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'CA', // Canada
  'CY', // Cyprus
  'CZ', // Czechia
  'DE', // Germany
  'DK', // Denmark
  'EE', // Estonia
  'ES', // Spain
  'FI', // Finland
  'FR', // France
  'GB', // United Kingdom
  'GR', // Greece
  'HR', // Croatia
  'HU', // Hungary
  'IN', // India
  'IE', // Ireland
  'IT', // Italy
  'LT', // Lithuania
  'LU', // Luxembourg
  'LV', // Latvia
  'MT', // Malta
  'NL', // Netherlands
  'XI', // Northern Ireland
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SE', // Sweden
  'SI', // Slovenia
  'SK', // Slovakia
]

export const anrokSupportedCanadianProvinces = [
  'QC', // Quebec
]
